import { Paragraph, Table, TableLayoutType, TableRow, TextRun, WidthType } from 'docx';

export const LINE_HEIGHT = { spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 } };

export const characterStyles = [
  {
    id: 'HeaderH1',
    name: 'Header H1',
    run: {
      font: 'Arial',
      size: 48,
      bold: true,
    },
  },
  {
    id: 'Subheader',
    name: 'Subheader',
    run: {
      font: 'Arial',
      size: 28,
    },
  },
  {
    id: 'SubheaderBoldH3',
    name: 'Subheader Bold H3',
    run: {
      font: 'Arial',
      size: 28,
      bold: true,
    },
  },
  {
    id: 'BaseText',
    name: 'Base Text',
    run: {
      font: 'Arial',
      size: 24,
    },
  },
  {
    id: 'SubheaderBoldH3Small',
    name: 'Subheader Bold H3 Small',
    run: {
      font: 'Arial',
      size: 24,
      bold: true,
    },
  },
];

// HeaderH1
export const HeaderH1 = (text: string) =>
  new TextRun({
    text: text || '',
    size: 48, // 24px ≈ 24pt ≈ 48 half-points
    font: 'Arial',
    bold: true,
  });

// Subheader
export const Subheader = (text: string) =>
  new TextRun({
    text: text || '',
    size: 28, // 14px ≈ 14pt ≈ 28 half-points
    font: 'Arial',
  });

// SubheaderBoldH3
export const SubheaderBoldH3 = (text: string) =>
  new TextRun({
    text: text || '',
    size: 28,
    font: 'Arial',
    bold: true,
  });

// BaseText
export const BaseText = (text: string) =>
  new TextRun({
    text: text || '',
    size: 24, // 12px
    font: 'Arial',
  });

// SubheaderBoldH3Small
export const SubheaderBoldH3Small = (text: string) =>
  new TextRun({
    text: text || '',
    size: 24,
    font: 'Arial',
    bold: true,
  });

export const Space = (breakLines = 1) =>
  new TextRun({
    break: breakLines,
  });

export const MyTable = ({
  rows,
  size = 10000,
  columnWidths = [720, 10000 - 720],
}: {
  rows: TableRow[];
  columnWidths?: number[];
  size?: number;
}): Table =>
  new Table({
    width: {
      size, // почти вся ширина страницы
      type: WidthType.DXA,
    },
    borders: {
      top: { style: 'none', size: 0, color: 'FFFFFF' },
      bottom: { style: 'none', size: 0, color: 'FFFFFF' },
      left: { style: 'none', size: 0, color: 'FFFFFF' },
      right: { style: 'none', size: 0, color: 'FFFFFF' },
      insideHorizontal: { style: 'none', size: 0, color: 'FFFFFF' },
      insideVertical: { style: 'none', size: 0, color: 'FFFFFF' },
    },
    layout: TableLayoutType.FIXED,
    columnWidths,
    rows,
  });

export const renderTextWithBreaks = (text: string): Paragraph[] => {
  const lines = text?.split('\n');

  return lines.map(
    (line) =>
      new Paragraph({
        children: [BaseText((line || '').trim())],
        ...LINE_HEIGHT,
      })
  );
};
